module.exports = __webpack_public_path__ + "img/help_drawer_mini.04eeb289.png";